<template>
	<div v-if="show" class="majorel-im-dialog-mask animated fadeIn">
		<el-container class="majorel-im-dialog-box" v-outside="closeBox">
			<el-header class="no-padding header" height="50px">
				<p>发送图文</p>
				<p class="tools">
					<i class="el-icon-close" @click="closeBox" />
				</p>
			</el-header>

			<el-main class="no-padding mian">
				<template >
					<card-message :data="source" keys="other"></card-message>
				</template>
			</el-main>

			<el-footer class="footer" height="50px">
				<el-button class="btn" type="primary" size="medium" :loading="loading" @click="uploadImage">立即发送
				</el-button>
			</el-footer>
		</el-container>
	</div>
</template>
<script>
	export default {
		name: 'EditorImageView',
		model: {
			prop: 'show',
			event: 'close',
		},
		props:{
			show:{
				default:false,
				type:Boolean
			},
			source:{
				default:''
			},
		},
		data() {
			return {
				loading: false,
			}
		},
		methods: {
			closeBox() {
				if (this.loading) {
					return false
				}

				this.$emit('close', false)
			},
			// 确认按钮事件
			uploadImage() {
				this.loading = true
				this.$emit('confirm')
			},
		},
	}
</script>
<style lang="scss" scoped>
	.majorel-im-dialog-box {
		width: 500px;
		max-width: 500px;
		height: 450px;
		background-color: #fff;
		.mian {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;

		}

		.footer {
			height: 50px;
			background: rgba(247, 245, 245, 0.66);
			text-align: center;
			line-height: 50px;

			.btn {
				width: 150px;
				border-radius: 2px;
			}
		}
	}
</style>
